import { create } from 'zustand';

export type DrawerItemType = 'order' | 'klant';

export interface BerichtenDrawerOpenItem {
  type: DrawerItemType;
  id: string;
}

interface BerichtenDrawerState {
  openItem: BerichtenDrawerOpenItem | null;
  open: (item: BerichtenDrawerOpenItem) => void;
  close: () => void;
}

export const useBerichtenDrawerStore = create<BerichtenDrawerState>((set) => ({
  openItem: null,
  open: (item) => set({ openItem: item }),
  close: () => set({ openItem: null }),
}));

/** Encode drawer state for the `?open=` query param. */
export function encodeDrawerParam(item: BerichtenDrawerOpenItem | null): string | null {
  if (!item) return null;
  return `${item.type}:${item.id}`;
}

/** Parse the `?open=` query param back into drawer state. */
export function parseDrawerParam(raw: string | null): BerichtenDrawerOpenItem | null {
  if (!raw) return null;
  const [type, ...rest] = raw.split(':');
  const id = rest.join(':');
  if (!id) return null;
  if (type === 'order' || type === 'klant') return { type, id };
  return null;
}
